export enum ImportLocationEnum {
    InProgress = 'InProgress',
    Documents = 'Documents',
}